// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dMq1","left":"styles_left__14kr-"};